export enum EKwikUIInputRadioChipSize {
  XS = "xs",
  S = "s",
  M = "m",
  L = "l",
  XL = "xl"
}
export const VKwikUIInputRadioChipSize = [
  EKwikUIInputRadioChipSize.XS,
  EKwikUIInputRadioChipSize.S,
  EKwikUIInputRadioChipSize.M,
  EKwikUIInputRadioChipSize.L,
  EKwikUIInputRadioChipSize.XL
] as const;

export type TKwikUIInputRadioChipSize =
  (typeof VKwikUIInputRadioChipSize)[number];

export enum EKwikUIInputRadioChipOrientation {
  VERTICAL = "vertical",
  HORIZONTAL = "horizontal",
  WRAPPED = "wrapped"
}
export const VKwikUIInputRadioChipOrientation = [
  EKwikUIInputRadioChipOrientation.HORIZONTAL,
  EKwikUIInputRadioChipOrientation.VERTICAL,
  EKwikUIInputRadioChipOrientation.WRAPPED
] as const;

export type TKwikUIInputRadioChipOrientation =
  (typeof VKwikUIInputRadioChipOrientation)[number];
